var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "analytics-content-container" },
    [
      _c(
        "div",
        { staticClass: "nav-header-container" },
        [
          _c("analytics-nav"),
          _vm._v(" "),
          _c(
            "v-date-picker",
            {
              staticClass: "daterange-picker",
              attrs: {
                "popover-direction": "bottom",
                "popover-align": "right",
                mode: "range",
                "show-caps": "",
                "drag-attribute": _vm.attribute,
                "select-attribute": _vm.attribute,
                value: _vm.getDateRange,
                "input-props": { style: _vm.dateInputStyle },
              },
              on: { drag: _vm.onDragDates, input: _vm.onInputDates },
            },
            [
              _c(
                "div",
                {
                  staticClass: "popover-content",
                  attrs: { slot: "popover" },
                  slot: "popover",
                },
                [
                  _c("p", [_vm._v(_vm._s(_vm.popStartDate))]),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.popEndDate))]),
                  _vm._v(" "),
                  _c("p", { staticClass: "days-nights" }, [
                    _c(
                      "span",
                      { staticClass: "days" },
                      [
                        _c("svg-icon", {
                          staticClass: "vc-sun-o",
                          attrs: { name: "sun" },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.popDays) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "nights" },
                      [
                        _c("svg-icon", {
                          staticClass: "vc-moon-o",
                          attrs: { name: "moon" },
                        }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.popDays) +
                            "\n          "
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }